import { AmountDto } from './amount.dto'
import { AccountResponseDto } from './account-details-response.dto';


export class TransactionResponseDto {
  additionalDataStructured?: any;
  additionalInformation?: string;
  additionalInformationStructured?: string;
  balanceAfterTransaction?: AmountDto;
  bankTransactionCode?: string;
  bookingDate?: string;
  bookingDateTime?: string;
  checkId?: string;
  creditorAccount?: AccountResponseDto;
  creditorAgent?: string;
  creditorId?: string;
  creditorName?: string;
  currencyExchange?: any[];
  debtorAccount?: AccountResponseDto;
  debtorAgent?: string;
  debtorName?: string;
  endToEndId?: string;
  entryReference?: string;
  internalTransactionId?: string;
  mandateId?: string;
  merchantCategoryCode?: string;
  proprietaryBankTransactionCode?: string;
  purposeCode?: string;
  remittanceInformationStructured?: string;
  remittanceInformationStructuredArray?: any[];
  remittanceInformationUnstructured: string;
  remittanceInformationUnstructuredArray?: string[];
  transactionAmount: AmountDto;
  transactionId: string;
  ultimateCreditor?: string;
  ultimateDebtor?: string;
  valueDate: string;
  valueDateTime?: string;
}

export class AccountTransactionResponseDto {
  booked: TransactionResponseDto[];
  pending: TransactionResponseDto[];
}


export class AccountTransactionsResponseDto {
  transactions: AccountTransactionResponseDto
}